import StaticPageLayout from "@/components/layout/StaticPageLayout";
import { useLanguage } from "@/context/LanguageContext";

export default function FAQs() {
  const { language } = useLanguage();

  const contentEn = (
    <div className="space-y-6 text-sm text-muted-foreground leading-relaxed">
      <div className="space-y-4">
        <h2 className="text-lg font-bold text-[#2A0A10]">General & Registration</h2>
        
        <section className="space-y-2">
          <h3 className="text-base font-bold text-primary">Is Hamarsathi completely free?</h3>
          <p>
            Registration, profile creation, uploading photos, browsing matches, and automated Kundli matching are 100% free of charge. Premium plans are optionally available if you want to unlock direct phone numbers/emails and avail of premium manager services.
          </p>
        </section>

        <section className="space-y-2">
          <h3 className="text-base font-bold text-primary">Who can create a profile on Hamarsathi?</h3>
          <p>
            Any individual of legal marriageable age in India (18+ for females, 21+ for males) who is seeking a lifetime matrimonial alliance can register. Profiles can be created by the candidates themselves, or by parents, siblings, or close relatives.
          </p>
        </section>
      </div>

      <div className="space-y-4 pt-4 border-t border-border/40">
        <h2 className="text-lg font-bold text-[#2A0A10]">Verification & Security</h2>

        <section className="space-y-2">
          <h3 className="text-base font-bold text-primary">How do I verify my profile?</h3>
          <p>
            Go to your dashboard, click "Verify Now", and upload a government-approved identity document (such as Aadhaar, Voter Card, or PAN). Our administration team reviews documents within 24 hours.
          </p>
        </section>

        <section className="space-y-2">
          <h3 className="text-base font-bold text-primary">What is the "Verified Badge"?</h3>
          <p>
            A green tick badge is displayed on profiles that have successfully completed government ID verification and selfie checks. Verified profiles receive up to 5x more matching requests.
          </p>
        </section>

        <section className="space-y-2">
          <h3 className="text-base font-bold text-primary">Can I control who sees my phone number or photos?</h3>
          <p>
            Yes! In the Privacy section of your dashboard, you can choose to make your photos visible only to members you accept, hide your phone number from public view, or request phone approval from every matched candidate.
          </p>
        </section>
      </div>

      <div className="space-y-4 pt-4 border-t border-border/40">
        <h2 className="text-lg font-bold text-[#2A0A10]">Kundli & Matching</h2>

        <section className="space-y-2">
          <h3 className="text-base font-bold text-primary">How does the Kundli Matching system work?</h3>
          <p>
            Enter the candidate's date, time, and exact place of birth during profile setup. Our platform automatically calculates Gun Milan (based on Ashtakoota) and displays the matching score out of 36 points instantly.
          </p>
        </section>

        <section className="space-y-2">
          <h3 className="text-base font-bold text-primary">What is the Vivah Mitra Program?</h3>
          <p>
            It is our unique local ambassador program where appointed individuals in each block/district of Jharkhand assist families in creating profiles, matching Kundli, and conducting local verifications to build community trust.
          </p>
        </section>
      </div>
    </div>
  );

  const contentHi = (
    <div className="space-y-6 text-sm text-muted-foreground leading-relaxed">
      <div className="space-y-4">
        <h2 className="text-lg font-bold text-[#2A0A10]">सामान्य और पंजीकरण</h2>
        
        <section className="space-y-2">
          <h3 className="text-base font-bold text-primary">क्या हमरसाथी पूरी तरह से मुफ्त है?</h3>
          <p>
            पंजीकरण, प्रोफ़ाइल निर्माण, फोटो अपलोड करना, मैच देखना और स्वचालित कुंडली मिलान पूरी तरह से निःशुल्क हैं। यदि आप सीधे फोन नंबर/ईमेल देखना चाहते हैं या प्रीमियम प्रबंधक सेवाओं का लाभ उठाना चाहते हैं, तो वैकल्पिक प्रीमियम प्लान उपलब्ध हैं।
          </p>
        </section>

        <section className="space-y-2">
          <h3 className="text-base font-bold text-primary">हमरसाथी पर कौन प्रोफ़ाइल बना सकता है?</h3>
          <p>
            भारत में विवाह की कानूनी आयु (महिलाओं के लिए 18+ और पुरुषों के लिए 21+) का कोई भी व्यक्ति, जो जीवनभर के लिए वैवाहिक गठबंधन की तलाश कर रहा है, पंजीकरण कर सकता है। प्रोफ़ाइल उम्मीदवार स्वयं, या उनके माता-पिता, भाई-बहन या करीबी रिश्तेदार बना सकते हैं।
          </p>
        </section>
      </div>

      <div className="space-y-4 pt-4 border-t border-border/40">
        <h2 className="text-lg font-bold text-[#2A0A10]">सत्यापन और सुरक्षा</h2>

        <section className="space-y-2">
          <h3 className="text-base font-bold text-primary">मैं अपनी प्रोफ़ाइल कैसे सत्यापित करूँ?</h3>
          <p>
            अपने डैशबोर्ड पर जाएं, "अभी सत्यापित करें" पर क्लिक करें, और सरकार द्वारा अनुमोदित पहचान पत्र (जैसे आधार, वोटर कार्ड या पैन) अपलोड करें। हमारी एडमिन टीम 24 घंटे के भीतर दस्तावेजों की समीक्षा करती है।
          </p>
        </section>

        <section className="space-y-2">
          <h3 className="text-base font-bold text-primary">"सत्यापित बैज" (Verified Badge) क्या है?</h3>
          <p>
            सफलतापूर्वक सरकारी आईडी सत्यापन और सेल्फी जांच पूरी करने वाले प्रोफाइल पर एक हरा टिक बैज दिखाया जाता है। सत्यापित प्रोफाइल को 5 गुना अधिक मैचिंग अनुरोध प्राप्त होते हैं।
          </p>
        </section>

        <section className="space-y-2">
          <h3 className="text-base font-bold text-primary">क्या मैं नियंत्रित कर सकता हूँ कि मेरा फोन नंबर या फोटो कौन देखेगा?</h3>
          <p>
            हाँ! आपके डैशबोर्ड के गोपनीयता अनुभाग में, आप अपनी तस्वीरों को केवल उन सदस्यों को दिखाने का विकल्प चुन सकते हैं जिन्हें आप स्वीकार करते हैं, अपने फोन नंबर को सार्वजनिक दृश्य से छिपा सकते हैं, या प्रत्येक मिलान वाले उम्मीदवार से फोन स्वीकृति का अनुरोध कर सकते हैं।
          </p>
        </section>
      </div>

      <div className="space-y-4 pt-4 border-t border-border/40">
        <h2 className="text-lg font-bold text-[#2A0A10]">कुंडली और मिलान</h2>

        <section className="space-y-2">
          <h3 className="text-base font-bold text-primary">कुंडली मिलान प्रणाली कैसे काम करती है?</h3>
          <p>
            प्रोफ़ाइल सेटअप के दौरान उम्मीदवार की जन्म तिथि, समय और जन्म का सटीक स्थान दर्ज करें। हमारा मंच अष्टकूट के आधार पर स्वचालित रूप से गुण मिलान की गणना करता है और तुरंत 36 अंकों में से स्कोर प्रदर्शित करता है।
          </p>
        </section>

        <section className="space-y-2">
          <h3 className="text-base font-bold text-primary">विवाह मित्र कार्यक्रम क्या है?</h3>
          <p>
            यह हमारा अनोखा स्थानीय राजदूत कार्यक्रम है जहाँ झारखंड के प्रत्येक ब्लॉक/जिले में नियुक्त व्यक्ति परिवारों को प्रोफाइल बनाने, कुंडली मिलाने और सामुदायिक विश्वास बनाने के लिए स्थानीय स्तर पर भौतिक सत्यापन करने में सहायता करते हैं।
          </p>
        </section>
      </div>
    </div>
  );

  return (
    <StaticPageLayout
      title={language === "hi" ? "पूछे जाने वाले प्रश्न" : "FAQs"}
      subtitle={language === "hi" ? "सामान्य प्रश्नों के त्वरित उत्तर" : "Quick answers to common questions"}
    >
      {language === "hi" ? contentHi : contentEn}
    </StaticPageLayout>
  );
}
